import { i18nKeys, useTranslation } from 'locales';
import { useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';
import CustomTable from 'shared/components/CustomTable';
import type { OnClickFunction } from 'types/html-type';
import type { CreditNote } from 'types/store/credit-note-state';
import type { LightInvoice } from 'types/store/invoice-state';

import type { LinkInvoiceFormFields } from './LinkInvoiceForm.types';
import { getLinkInvoiceFormFieldLine } from './LinkInvoiceForm.utils';
import { LinkInvoiceFormTableItem } from './LinkInvoiceFormTableItem';

const GroupedTable = CustomTable(LinkInvoiceFormTableItem);

type Props = {
  creditNote: CreditNote;
  invoices: LightInvoice[];
  className?: string;
  reload?: OnClickFunction;
};

export const LinkInvoiceFormTable = ({ creditNote, invoices, className, reload }: Props) => {
  const { t } = useTranslation();

  const headers = [
    {
      title: t(i18nKeys.FORM.REFERENCE),
    },
    {
      title: t(i18nKeys.ISSUE_DATE),
    },
    {
      title: t(i18nKeys.FORM.CHOOSE_INVOICES.REMAINING_AMOUNT),
    },
    {
      title: t(i18nKeys.LATE_FEES_INCLUDED),
    },
    {
      title: '',
    },
    {
      title: t(i18nKeys.AMOUNT),
    },
  ];

  const { fields, replace } = useFieldArray<LinkInvoiceFormFields>({
    name: 'invoices_to_link',
  });

  useEffect(() => {
    replace(
      invoices.map(e => getLinkInvoiceFormFieldLine(e, creditNote.matched_payments_attributes)),
    );
  }, [invoices, creditNote, replace]);

  return (
    <GroupedTable
      className={className}
      items={fields}
      itemProps={{ creditNote, invoices, reload }}
      noMargin
      noCheckbox
      headers={headers}
    />
  );
};
